module.exports = {"timelineGap":"15","timelineGapMobile":"10","timelineTopMargin":"60","timelineTopMarginMobile":"40"};